module.exports = __webpack_public_path__ + "img/medalla.38bb9174.png";